import { AutoMap } from "@automapper/classes";
import { ClientDTO } from "./client.dto";
import { ProductGroupDTO } from "./product-group.dto";
import { LimitCategoryDTO } from "./limit-category.dto";

export class ConfigurationDTO {

    @AutoMap()
    name: string = '';

    @AutoMap()
    code: string = '';
    @AutoMap()
    isActive: boolean = false;
    @AutoMap()
    testGroupForeColor: string = '';
    @AutoMap()
    testGroupBackColor: string = '';
    @AutoMap()
    testForeColor: string = '';
    @AutoMap()
    testBackColor: string = '';
    @AutoMap()
    displayEmptyGroups: boolean = false;
    @AutoMap()
    displayEmptyTests: boolean = false; 
    @AutoMap()
    isMaster: boolean = false;
    @AutoMap()
    exportNote: string = '';  
    @AutoMap()
    displayComparateurLQ: boolean = false;
    @AutoMap()
    displayDND: boolean = false;
    @AutoMap()
    createdOn?: Date
    @AutoMap()
    modifiedOn?: Date
    @AutoMap()
    createdByEmail: string = '';
    @AutoMap()
    modifiedByEmail: string = '';
    @AutoMap()

    useComaAsDecimalSeparator: boolean = false
    @AutoMap()
    outOfLimitFontBold: boolean = false
    @AutoMap()
    outOfLimitFontItalic: boolean = false
    @AutoMap()
    useLeftMostLimit: boolean = false;
    @AutoMap()
    withParameterCodeColumn: boolean = false;
    @AutoMap()
    withCASNumberColumn: boolean = false;
    @AutoMap()
    withLOQColumn: boolean = false;
    @AutoMap()
    withMethodColumn: boolean = false;
    @AutoMap()
    withLOQIncertitudeColumn: boolean = false;
    @AutoMap()
    withBarcodeRow: boolean = false;
    @AutoMap()
    withPSVNameRow: boolean = false;
    @AutoMap()
    hasBilanConformite: boolean = false;
    logo?: File;
    logoToBase64: string = '';

    @AutoMap(() => [LimitCategoryDTO])
    limitCategoryList: LimitCategoryDTO[] = [];
    @AutoMap(() => [ProductGroupDTO])
    productGroupList: ProductGroupDTO[] = [];
    /**
     * Only for Master Configuration
     */
    @AutoMap(() => [ClientDTO])
    clientList: ClientDTO[] = [];

}